import styles from './TimelineDot.module.css';

interface TimelineDotProps {
  isLatest: boolean;
  showLine: boolean;
}

export default function TimelineDot({ isLatest, showLine }: TimelineDotProps) {
  return (
    <div className={styles.spine}>
      <div className={styles.dot} data-latest={isLatest || undefined} />
      {showLine && <div className={styles.line} />}
    </div>
  );
}
